module.exports = __webpack_public_path__ + "img/金贝特.b517cfcd.jpg";